import { EObjectType } from '../../types/filters';

interface IObjectType {
  label: string;
  value: EObjectType;
}

export const OBJECT_TYPES: IObjectType[] = [
  { label: 'Коттеджи', value: EObjectType.Cottage },
  { label: 'Участки', value: EObjectType.Landplot },
  { label: 'Таунхаусы', value: EObjectType.Townhouse },
  { label: 'Малоэтажные дома', value: EObjectType.Lowrisehouse },
];
